export default function ({ store, redirect, route }) {
  const auth = store.state.auth;
  const is_admin = auth.is_admin;
  let is_pass = true

  if (!is_admin) {
    is_pass = false
  }

  if (!is_pass) {
    const user_permissions = auth.permissionNames;
    is_pass = route.meta.some((meta) => {
      if (meta.user_permission_names !== undefined) {
        return collect(meta.user_permission_names).diff(user_permissions).count() == 0
      }

      return false
    });
  }

  if (!is_pass) {
    return redirect('/panel');
  }
}
